import React from "react";
import { connect } from "react-redux";
import * as Type from "@interface/index";
import { Link, withRouter } from "react-router-dom";

interface PropsInterface extends Type.ComponentInterface {}

interface StateInterface {}

class About extends React.Component<PropsInterface, StateInterface> {
  public dataMarkup() {
    return { __html: this.props.Store.Company.Current.data?.description };
  }

  public render() {
    return (
      <>
        {this.props.Store.Company.Current.data?.description ||
        this.props.Store.Company.Current.data?.directions?.length > 0 ? (
          <>
            <div className="stand__block stand-about">
              <div className="stand-about__title">О нас</div>
              {Number(this.props.match.params.company_id) ===
                this.props.Store.Auth.data?.company?.id && this.props.Store.Auth.data?.isAdmin ? (
                <div className="stand-about__change-link">
                  <Link to={`/company/${this.props.match.params.company_id}/edit`}>Изменить</Link>
                </div>
              ) : (
                <></>
              )}
              <div className="stand-about__content" dangerouslySetInnerHTML={this.dataMarkup()} />

              {this.props.Store.Company.Current.data?.directions?.length > 0 ? (
                <>
                  <div className="stand-about__directions">
                    <div className="stand-about__directions-title">
                      Направления, с которыми мы работаем
                    </div>
                    <div className="stand-about__directions-list">
                      {this.props.Store.Company.Direction.list
                        .filter((direction) =>
                          this.props.Store.Company.Current.data?.directions?.includes(direction.id)
                        )
                        .map((direction: any, index: number) => {
                          return (index === 0 ? "" : ", ") + direction.name;
                        })}
                    </div>
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>
          </>
        ) : (
          <></>
        )}
      </>
    );
  }
}

export default withRouter(
  connect(
    (Store: any) => {
      return { Store };
    },
    (Dispatch: (action: any) => void) => {
      return { Dispatch: (action: any) => Dispatch(action) };
    }
  )(About)
);
